import { genericGETJson } from '@/services/genericGETJson'

async function getProducto (params = null) {
  return await genericGETJson(
    '/api/productos/getproductodetalle',
    null,
    params
  )
}

export { getProducto }
